import React from 'react';

const QuickLinks = () => {
  const links = [
    {
      title: 'SL UNIRED',
      description: 'Accede a la plataforma',
      url: 'https://webslunired.facach.com/FACACHWeb/',
      color: '#1a4f9e',
      bgColor: '#E6F1FB',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
    },
    {
      title: 'SEC',
      description: 'Sistema de evaluación',
      url: 'https://sci.facach.com:8251/logon.aspx?ReturnUrl=%2f',
      color: '#f47920',
      bgColor: '#FDEBD9',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
      ),
    },
    {
      title: 'Balance Social',
      description: 'Balance cooperativo',
      url: 'http://dgrv.facach.com:9120/bsc/inicio',
      color: '#3aaa35',
      bgColor: '#E4F3DD',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="8" y1="13" x2="16" y2="13" />
          <line x1="8" y1="17" x2="16" y2="17" />
        </svg>
      ),
    },
  ];

  return (
    <section className="quick-links-section">
      <div className="quick-links-container">
        {links.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="quick-link-card"
            style={{ '--accent-color': link.color, '--accent-bg': link.bgColor }}
          >
            <div className="quick-link-icon" style={{ backgroundColor: link.bgColor, color: link.color }}>
              {link.icon}
            </div>
            <div className="quick-link-text">
              <h4>{link.title}</h4>
              <p>{link.description}</p>
            </div>
            <div className="quick-link-arrow" style={{ color: link.color }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </div>
          </a>
        ))}
      </div>

      <style>{`
        .quick-links-section {
          padding: 2rem 1rem;
          background: linear-gradient(135deg, #f8f9fc 0%, #eef2f9 100%);
        }

        .quick-links-container {
          max-width: 1100px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1rem;
        }

        .quick-link-card {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 18px 20px;
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          text-decoration: none;
          color: inherit;
          transition: all 0.25s ease;
          position: relative;
          overflow: hidden;
        }

        .quick-link-card::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 4px;
          background: var(--accent-color);
          transform: scaleY(0);
          transform-origin: bottom;
          transition: transform 0.25s ease;
        }

        .quick-link-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(26, 79, 158, 0.1);
          border-color: var(--accent-color);
        }

        .quick-link-card:hover::before {
          transform: scaleY(1);
        }

        .quick-link-card:hover .quick-link-arrow {
          transform: translateX(4px);
        }

        .quick-link-icon {
          width: 46px;
          height: 46px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .quick-link-text {
          flex: 1;
          min-width: 0;
        }

        .quick-link-text h4 {
          margin: 0;
          font-size: 15px;
          font-weight: 600;
          color: #1f2937;
          line-height: 1.2;
        }

        .quick-link-text p {
          margin: 3px 0 0;
          font-size: 13px;
          color: #6b7280;
          line-height: 1.3;
        }

        .quick-link-arrow {
          flex-shrink: 0;
          transition: transform 0.25s ease;
          display: flex;
          align-items: center;
        }

        @media (max-width: 768px) {
          .quick-links-container {
            grid-template-columns: 1fr;
            gap: 0.75rem;
          }

          .quick-links-section {
            padding: 1.5rem 1rem;
          }
        }
      `}</style>
    </section>
  );
};

export default QuickLinks;
